/* Jumocart redesign — behaviour. No dependencies, no jQuery. */
(function () {
  'use strict';

  var DEVICE_KEY = 'jc:device';

  /* ---------- device memory ------------------------------------------- */
  var Device = {
    get: function () {
      try { return localStorage.getItem(DEVICE_KEY) || ''; } catch (e) { return ''; }
    },
    set: function (name) {
      try { localStorage.setItem(DEVICE_KEY, name); } catch (e) {}
      document.dispatchEvent(new CustomEvent('jc:device', { detail: { name: name } }));
    },
    clear: function () {
      try { localStorage.removeItem(DEVICE_KEY); } catch (e) {}
      document.dispatchEvent(new CustomEvent('jc:device', { detail: { name: '' } }));
    },
    norm: function (s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  };
  window.JCDevice = Device;

  function paintDeviceChips() {
    var name = Device.get();
    document.querySelectorAll('[data-jc-device-chip]').forEach(function (el) {
      var val = el.querySelector('[data-jc-device-value]');
      var lab = el.querySelector('[data-jc-device-label]');
      if (val) val.textContent = name || el.getAttribute('data-empty-value') || 'Choose model';
      if (lab) lab.textContent = name ? 'My device' : 'Set device';
      el.classList.toggle('jc-mydevice--set', !!name);
    });
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-jc-set-device]');
    if (pick) {
      e.preventDefault();
      Device.set(pick.getAttribute('data-jc-set-device'));
      return;
    }
    var clear = e.target.closest('[data-jc-clear-device]');
    if (clear) { e.preventDefault(); Device.clear(); }
  });

  document.addEventListener('jc:device', function () {
    paintDeviceChips();
    document.querySelectorAll('[data-jc-fit]').forEach(initCompat);
  });

  /* ---------- category hero menu --------------------------------------- */
  function initCategoryMenu(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';

    var depts = Array.prototype.slice.call(root.querySelectorAll('[data-jc-dept]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-jc-panel]'));
    var isTouch = window.matchMedia('(hover: none)').matches;

    function show(id, drill) {
      depts.forEach(function (d) { d.setAttribute('aria-selected', String(d.getAttribute('data-jc-dept') === id)); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-jc-panel') !== id; });
      if (drill) root.setAttribute('data-drilled', 'true');
    }

    depts.forEach(function (d) {
      var id = d.getAttribute('data-jc-dept');
      if (!isTouch) {
        d.addEventListener('mouseenter', function () { show(id, false); });
        d.addEventListener('focus', function () { show(id, false); });
      }
      d.addEventListener('click', function (e) {
        // On narrow screens the first tap drills in rather than navigating.
        if (window.innerWidth <= 860) { e.preventDefault(); show(id, true); }
        else { show(id, false); }
      });
      d.addEventListener('keydown', function (e) {
        var i = depts.indexOf(d);
        if (e.key === 'ArrowDown') { e.preventDefault(); (depts[i + 1] || depts[0]).focus(); }
        if (e.key === 'ArrowUp') { e.preventDefault(); (depts[i - 1] || depts[depts.length - 1]).focus(); }
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          var panel = root.querySelector('[data-jc-panel="' + id + '"]:not([hidden]) a');
          if (panel) panel.focus();
        }
      });
    });

    var back = root.querySelector('[data-jc-back]');
    if (back) back.addEventListener('click', function () { root.removeAttribute('data-drilled'); });
  }

  /* ---------- command-bar category filter ------------------------------ */
  function initCommandBar(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';
    var input = root.querySelector('input');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-jc-cat]'));
    var empty = root.querySelector('[data-jc-cmd-empty]');
    var limit = parseInt(root.getAttribute('data-limit') || '10', 10);

    function run() {
      var q = (input.value || '').toLowerCase().trim();
      var shown = 0;
      rows.forEach(function (r) {
        var hit = !q || r.getAttribute('data-jc-cat').indexOf(q) > -1;
        var visible = hit && shown < limit;
        r.hidden = !visible;
        if (visible) shown++;
      });
      if (empty) empty.hidden = shown !== 0;
    }
    input.addEventListener('input', run);
    run();
  }

  /* ---------- product gallery ------------------------------------------ */
  function initGallery(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jc-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-jc-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-jc-dot]'));
    var counter = root.querySelector('[data-jc-counter]');

    function go(i) {
      slides.forEach(function (s, k) { s.setAttribute('data-active', String(k === i)); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', String(k === i)); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    root.addEventListener('jc:showimage', function (e) {
      var src = e.detail && e.detail.src;
      if (!src) return;
      var idx = slides.findIndex(function (s) {
        var img = s.querySelector('img');
        return img && (img.getAttribute('src') === src || img.getAttribute('data-src') === src);
      });
      if (idx > -1) { go(idx); return; }
      // Option image is not in the gallery — inject it as an extra slide.
      var slide = document.createElement('div');
      slide.className = 'jc-gal__slide';
      slide.setAttribute('data-jc-slide', '');
      slide.innerHTML = '<img src="' + src.replace(/"/g, '&quot;') + '" alt="" loading="lazy" width="1000" height="1000">';
      root.querySelector('[data-jc-stage]').appendChild(slide);
      slides.push(slide);
      go(slides.length - 1);
    });
    go(0);
  }

  /* ---------- custom option selector (tvc.variants) --------------------- */
  function initOptions(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-jc-opt]'));
    var out = root.querySelector('[data-jc-opt-value]');
    var gallery = document.querySelector('[data-jc-gallery]');

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        if (out) out.textContent = b.getAttribute('data-jc-opt');
        var img = b.getAttribute('data-image');
        if (img && gallery) gallery.dispatchEvent(new CustomEvent('jc:showimage', { detail: { src: img } }));
      });
    });
  }

  /* ---------- compatibility module -------------------------------------- */
  function initCompat(root) {
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-jc-chip]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-jc-fit-group]'));
    var input = root.querySelector('[data-jc-fit-search]');
    var matches = root.querySelector('[data-jc-fit-matches]');
    var more = root.querySelector('[data-jc-fit-more]');
    var empty = root.querySelector('[data-jc-fit-empty]');
    var head = root.querySelector('[data-jc-fit-head]');
    var title = root.querySelector('[data-jc-fit-title]');
    var sub = root.querySelector('[data-jc-fit-sub]');
    var collapsed = root.getAttribute('data-expanded') !== 'true';
    var LIMIT = parseInt(root.getAttribute('data-limit') || '12', 10);
    var total = chips.length;
    var device = Device.get();
    var dn = Device.norm(device);

    // flag the shopper's device
    var mine = null;
    chips.forEach(function (c) {
      var isMine = dn && Device.norm(c.getAttribute('data-jc-chip')) === dn;
      c.classList.toggle('jc-fit__chip--mine', !!isMine);
      var tick = c.querySelector('[data-jc-tick]');
      if (tick) tick.hidden = !isMine;
      if (isMine) mine = c;
    });

    if (title && head) {
      root.classList.remove('jc-fit--match', 'jc-fit--miss');
      if (!device) {
        title.textContent = root.getAttribute('data-label-unset') || ('Compatible with ' + total + ' devices');
        if (sub) sub.textContent = 'Set your device and we will check it for you.';
      } else if (mine) {
        root.classList.add('jc-fit--match');
        title.textContent = 'Fits your ' + device;
        if (sub) sub.textContent = 'Confirmed against the supplier fitment list.';
      } else {
        root.classList.add('jc-fit--miss');
        title.textContent = 'Not listed for your ' + device;
        if (sub) sub.textContent = 'Search the full fitment list below, or change your device.';
      }
    }

    function render() {
      var q = input ? (input.value || '').toLowerCase().trim() : '';
      var hits = 0, shown = 0;
      chips.forEach(function (c) {
        var hit = !q || c.getAttribute('data-jc-chip').toLowerCase().indexOf(q) > -1;
        if (hit) hits++;
        var visible = hit && (!collapsed || shown < LIMIT || c === mine);
        c.hidden = !visible;
        if (visible) shown++;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-jc-chip]:not([hidden])');
      });
      if (matches) matches.textContent = q ? hits + (hits === 1 ? ' match' : ' matches') : total + ' devices';
      if (empty) empty.hidden = hits !== 0;
      if (more) {
        more.hidden = hits <= LIMIT;
        more.textContent = collapsed ? 'Show all ' + hits + ' devices' : 'Show fewer';
      }
    }

    if (input && !input.dataset.jcReady) {
      input.dataset.jcReady = '1';
      input.addEventListener('input', render);
    }
    if (more && !more.dataset.jcReady) {
      more.dataset.jcReady = '1';
      more.addEventListener('click', function () { collapsed = !collapsed; render(); });
    }
    render();
  }

  /* ---------- quantity -------------------------------------------------- */
  function initQty(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';
    var input = root.querySelector('input');
    root.querySelectorAll('[data-jc-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var step = parseInt(b.getAttribute('data-jc-step'), 10);
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- collection: density + filter sheet ------------------------ */
  function initDensity(root) {
    if (root.dataset.jcReady) return;
    root.dataset.jcReady = '1';
    var grid = document.querySelector('[data-jc-grid]');
    var saved = null;
    try { saved = localStorage.getItem('jc:density'); } catch (e) {}
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-jc-density]'));

    function apply(n) {
      if (grid) grid.style.setProperty('--jc-cols', n);
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-jc-density') === String(n))); });
      try { localStorage.setItem('jc:density', n); } catch (e) {}
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-jc-density')); });
    });
    if (saved) apply(saved);
  }

  function initSheet(sheet) {
    if (sheet.dataset.jcReady) return;
    sheet.dataset.jcReady = '1';
    var id = sheet.getAttribute('data-jc-sheet');
    function close() { sheet.removeAttribute('open'); document.body.style.overflow = ''; }
    function open() { sheet.setAttribute('open', ''); document.body.style.overflow = 'hidden'; }
    document.querySelectorAll('[data-jc-sheet-open="' + id + '"]').forEach(function (b) {
      b.addEventListener('click', open);
    });
    sheet.querySelectorAll('[data-jc-sheet-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- copy SKU --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-jc-copy]');
    if (!el) return;
    var text = el.getAttribute('data-jc-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(text);
    var label = el.querySelector('.jc-sku__label');
    if (label) {
      var was = label.textContent;
      label.textContent = 'Copied';
      setTimeout(function () { label.textContent = was; }, 1400);
    }
  });

  /* ---------- boot ------------------------------------------------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-jc-catmenu]').forEach(initCategoryMenu);
    (scope || document).querySelectorAll('[data-jc-cmdbar]').forEach(initCommandBar);
    (scope || document).querySelectorAll('[data-jc-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-jc-opts]').forEach(initOptions);
    (scope || document).querySelectorAll('[data-jc-fit]').forEach(initCompat);
    (scope || document).querySelectorAll('[data-jc-qty]').forEach(initQty);
    (scope || document).querySelectorAll('[data-jc-densityset]').forEach(initDensity);
    (scope || document).querySelectorAll('[data-jc-sheet]').forEach(initSheet);
    paintDeviceChips();
  }

  /* Subcategory chips, hydrated from the category tree asset.
     There are 2,819 collections and Shopify menus only nest three deep, so a menu per
     collection is not viable — the whole tree ships as one cached JSON asset instead. */
  var treeCache = null;
  function loadTree(src) {
    if (treeCache) return treeCache;
    treeCache = fetch(src).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
    return treeCache;
  }

  function initSubcats(el) {
    if (el.__jcDone) return;
    el.__jcDone = true;
    var code = el.getAttribute('data-code');
    var src = el.getAttribute('data-src');
    var root = el.getAttribute('data-root') || '/';
    if (!code || !src) return;
    loadTree(src).then(function (data) {
      var node = data.nodes && data.nodes[code];
      if (!node || !node.k || !node.k.length) return;
      var frag = document.createDocumentFragment();
      node.k.forEach(function (childCode) {
        var c = data.nodes[childCode];
        if (!c) return;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'jc-chip';
        a.href = root.replace(/\/$/, '') + '/collections/' + c.h;
        a.textContent = c.n;
        if (c.c > 0) {
          var s = document.createElement('span');
          s.className = 'jc-chip__count';
          s.textContent = c.c.toLocaleString();
          a.appendChild(s);
        }
        li.appendChild(a);
        frag.appendChild(li);
      });
      el.appendChild(frag);
      el.hidden = false;
    }).catch(function () { /* asset missing — leave chips hidden */ });
  }

  var _boot = boot;
  boot = function (scope) {
    _boot(scope);
    (scope || document).querySelectorAll('[data-jc-subcats]').forEach(initSubcats);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
